import { Filter, FilterActions } from '@gogame/filters';
import React from 'react';

const TrafficTypeFilter = (props) => (
  <Filter.Select
    title={'Traffic type'}
    placeholder={'Select Traffic type'}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);
export default TrafficTypeFilter;
